export enum Device {
    Smartphone="smartphone",
    Tablet="tablet",
    Desktop="desktop",
    Fullscreen="fullscreen"
}